import { TmsStatePanel } from "@/components/tms/TmsStatePanel";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { useFleetMode } from "@/lib/tms/fleet-mode-context";
import { getFleetModePageRestriction, type FleetModeRestrictedPage } from "@/lib/tms/fleet-mode";
import * as React from "react";
import { useNavigate } from "react-router-dom";

export function FleetModePageGate({
  page,
  children,
}: {
  page: FleetModeRestrictedPage;
  children: React.ReactNode;
}) {
  const navigate = useNavigate();
  const { fleetMode, loading } = useFleetMode();

  const restriction = React.useMemo(
    () => getFleetModePageRestriction(page, fleetMode),
    [fleetMode, page],
  );

  if (loading) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-48 w-full" />
      </div>
    );
  }

  if (!restriction) return <>{children}</>;

  return (
    <div className="max-w-3xl space-y-4">
      <div>
        <h1 className="text-xl font-semibold">Workspace Access Changed</h1>
        <p className="text-sm text-muted-foreground">
          This page is unavailable under the current workspace mode.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">{restriction.title}</CardTitle>
        </CardHeader>
        <CardContent>
          <TmsStatePanel
            tone="filtered"
            title="Update workspace mode to restore this area."
            description={restriction.description}
            actionLabel="Open TMS Settings"
            onAction={() => navigate("/account/settings")}
            className="py-8"
          />
        </CardContent>
      </Card>
    </div>
  );
}
